import { ApolloProvider } from '@apollo/client/react';
import { ApolloClient } from '@apollo/client';
import { RouterProvider } from 'react-router';
import { Leva } from 'leva';

export type AppProps = React.ComponentProps<typeof RouterProvider> & {
  client: ApolloClient<unknown>;
};

export const App: React.FC<AppProps> = ({ client, router }) => {
  return (
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
      <Leva hidden={new URLSearchParams(document.location.search).has('debug') === false} />
    </ApolloProvider>
  );
};
